"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dateCompare = function (validFrom, validTo) {
    var isInRange;
    var currentDate = new Date();
    var compareVal = currentDate.getTime();
    // valid from
    var validFromVal = validFrom ? new Date(validFrom) : new Date();
    var validFromCompare = validFromVal.getTime();
    isInRange = validFromCompare <= compareVal;
    // valid to
    if (validTo) {
        var validToVal = new Date(validTo);
        var validToCompare = validToVal.getTime();
        isInRange =
            (validFromCompare < compareVal && validToCompare >= compareVal) ||
                (!validFrom && compareVal <= validToCompare);
    }
    return isInRange;
};
exports.default = dateCompare;
//# sourceMappingURL=dateCompare.js.map